import { timelineItems } from '@/mocks/home';

export default function UpdateTimeline() {
  return (
    <section id="updates" className="bg-background-100 border-y border-background-200">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <p className="text-xs font-label font-medium text-primary-600 tracking-wide mb-2">
              近期更新
            </p>
            <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">
              最近都在更什么
            </h2>
            <p className="mt-3 text-sm font-label text-foreground-600 leading-relaxed">
              更新条里的动静在这里留痕。想知道一个主播有没有按时更新、某个话题有没有补内容，看这条时间线就够了。
            </p>
            <a
              href="#faq"
              className="mt-6 inline-flex items-center gap-1.5 h-10 px-5 rounded-md bg-foreground-950 text-background-50 text-sm font-label font-medium hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              更新规则说明
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="lg:col-span-8">
            <ol className="relative pl-6">
              <span className="absolute left-[7px] top-2 bottom-2 w-px bg-background-300"></span>
              {timelineItems.map((item, index) => (
                <li key={item.text} className="relative pb-6 last:pb-0">
                  <span
                    className={[
                      'absolute -left-6 top-1 w-3.5 h-3.5 rounded-full border-2 border-background-100',
                      index === 0 ? 'bg-primary-500' : 'bg-accent-500',
                    ].join(' ')}
                  ></span>
                  <div className="rounded-lg border border-background-200 bg-background-50 px-4 py-3">
                    <p className="text-xs font-label text-primary-600">{item.time}</p>
                    <p className="mt-1 text-sm font-label text-foreground-800 leading-relaxed">
                      {item.text}
                    </p>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}